import { ListingType } from "@redotech/cockroachdb-codegen/tables/product/listing-type";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ListingTypeSchema = createEnum(ListingType);

export const BaseProductFamilyListingSchema = z.object({
  listingType: ListingTypeSchema,
  productFamilyId: productFamilyIdFormat.schema,
});

export const BaseProductListingSchema = z.object({
  listingType: ListingTypeSchema,
  productId: productIdFormat.schema,
});
